<template>
    <div>
        <span v-html="getPlanType()">
        </span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "PlanStarted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        getPlanType() {
            if (this.$_.get(this.activity, "payload.details")) {
                return this.$t("notification.planStartedAgent", {
                    user: this.$_.get(this.activity, "actorUser.name"),
                    title: this.$_.get(this.activity, "payload.title"),
                    altTitle: this.$_.get(this.activity, "payload.altTitle"),
                    details: this.$_.get(this.activity, "payload.details"),
                });
            } else if (this.$_.get(this.activity, "payload.detailsChatbot")) {
                return this.$t("notification.planStartedChatbot", {
                    user: this.$_.get(this.activity, "actorUser.name"),
                    title: this.$_.get(this.activity, "payload.title"),
                    altTitle: this.$_.get(this.activity, "payload.altTitle"),
                    chatbot: this.$_.get(this.activity, "payload.detailsChatbot"),
                });
            } else if (this.$_.get(this.activity, "payload.detailsWp")) {
                return this.$t("notification.planStartedWhatsapp", {
                    user: this.$_.get(this.activity, "actorUser.name"),
                    title: this.$_.get(this.activity, "payload.title"),
                    altTitle: this.$_.get(this.activity, "payload.altTitle"),
                    whatsapp: this.$_.get(this.activity, "payload.detailsWp"),
                });
            } else if (this.$_.get(this.activity, "payload.detailWpApi")) {
                return this.$t("notification.planStartedWhatsappApi", {
                    user: this.$_.get(this.activity, "actorUser.name"),
                    title: this.$_.get(this.activity, "payload.title"),
                    altTitle: this.$_.get(this.activity, "payload.altTitle"),
                    whatsappApi: this.$_.get(this.activity, "payload.detailWpApi"),
                });
            }
        },
    },
});
</script>

<style scoped lang="scss"></style>
